<button
    (click)="copyLinkToClipboard(permalink)"
    class="transparent"
    hisImage="copy">
    {{ "common.permalink.action.copyToClipboard" | hisUi }}
</button>
<a
    [href]="permalink"
    class="transparent"
    target="_blank"
    hisImage="new_window">
    {{ "common.permalink.action.openInNewWindow" | hisUi }}
</a>
